import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "@environments/environment";
import { FobScannedDto } from "@interfaces/dto/fobScannedDto.interface";
import { StaffAttendanceService } from "@services/staffAttendance.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "clocking",
	styleUrls: ["clocking.css"],
	templateUrl: "clocking.html"
})
export class ClockingAdminComponent implements OnInit, OnDestroy {
	avatar = "";
	clockInTime = "";
	companyName = "";
	copyright = "";
	currentDate = "";
	currentTime = "";
	fobScannedEntity = new FobScannedDto();
	isLoading = false;
	isScanZoneActive = false;
	// --- RFID buffering state ---
	private lastKeyTime = 0;
	private modalTimerId: any;
	mode = "In";
	private rfidBuffer = "";
	/** max gap between characters (ms) before we treat it as a new scan */
	private rfidTimeout = 100; // scanners are usually very fast
	showModal = false;
	siteId = 0;
	private timeIntervalId: any;
	userName = "John Doe";


	constructor(private route: ActivatedRoute, private toastService: ToastService, private staffAttendanceService: StaffAttendanceService) {
		this.companyName = this.getEnvironmentProperty("companyLongName");
		this.copyright = "© Copyright " + this.companyName + " " + new Date().getFullYear();
		// this.showModal=true;
		this.route.params
			.subscribe((params) => {
				this.siteId = Number.parseInt(params.id);
			});
	}

	closeModal(): void {
		this.showModal = false;
		this.isScanZoneActive = false;

		if (this.modalTimerId) {
			clearTimeout(this.modalTimerId);
			this.modalTimerId = null;
		}
	}

	getEnvironmentProperty(property: string) {
		// @ts-ignore // Required to get around having to iterate through the object
		return environment["build"][property];
	}

	// ==========================
	//  RFID keyboard listener
	// ==========================
	@HostListener("window:keydown", ["$event"])
	handleKeydown(event: KeyboardEvent): void {
		const now = Date.now();
		console.log("INPUT DETECTED");

		// Reset buffer if there was a long pause (likely user typing, not scanner)
		if (now - this.lastKeyTime > this.rfidTimeout) {
			this.rfidBuffer = "";
		}
		this.lastKeyTime = now;

		// If Enter is pressed, treat current buffer as full scan
		if (event.key === "Enter") {
			if (this.rfidBuffer.length > 0) {
				const scannedCode = this.rfidBuffer;
				this.rfidBuffer = "";
				// Run your handler
				this.submitData(scannedCode);

				// Optional: prevent Enter from triggering buttons/forms
				event.preventDefault();
				event.stopPropagation();
			}
			return;
		}

		// Only collect printable characters (scanner input)
		if (event.key.length === 1) {
			this.rfidBuffer += event.key;
		}
	}

	ngOnDestroy(): void {
		if (this.timeIntervalId) {
			clearInterval(this.timeIntervalId);
		}
	}

	ngOnInit(): void {
		this.updateTime();
		this.timeIntervalId = setInterval(() => this.updateTime(), 1000);
	}

	onManualEntryClick(): void {
		const employeeId = window.prompt("Enter your Employee ID:");
		if (employeeId) {
			this.clockInTime = new Date().toLocaleTimeString("en-US", {
				hour: "numeric",
				hour12: true,
				minute: "2-digit",
				second: "2-digit"
			});
			this.showModal = true;
		}
	}

	onScanZoneClick(): void {
		this.isScanZoneActive = true;

		// setTimeout(() => {
		// 	this.clockInTime = new Date().toLocaleTimeString("en-US", {
		// 		hour: "numeric",
		// 		hour12: true,
		// 		minute: "2-digit",
		// 		second: "2-digit"
		// 	});
		// 	this.showModal = true;
		// }, 1500);
	}

	private openModal(): void {
		this.showModal = true;
		this.isLoading = false;

		// Clear any existing timer so scans don't stack timers
		if (this.modalTimerId) {
			clearTimeout(this.modalTimerId);
		}

		this.modalTimerId = setTimeout(() => {
			this.closeModal();
		}, 2000); // 3 seconds
	}

	submitData(fobId: string) {
		this.isLoading = true;
		this.isScanZoneActive = true;
		this.fobScannedEntity.siteId = this.siteId;
		this.fobScannedEntity.fobId = fobId;
		this.staffAttendanceService.app_fobScanned(this.fobScannedEntity)
			.subscribe(
				(res: any) => {
					// this.toastService.success("Fob Scanned Successfully!");
					setTimeout(() => {
						console.log(res.response.userProfileFullName);
						this.userName = res.response.userProfileFullName;
						if(res.response.userProfileAvatarUrl === null || res.response.userProfileAvatarUrl === undefined){
							if(this.userName.substring(0,2).toLowerCase() == "mr"){
								this.avatar = "https://ui-avatars.com/api/?name=" + this.userName.split(" ")[1].substring(0,1) + "+" + this.userName.split(" ")[2].substring(0,1) + "&size=512&background=344281&color=ffffff";
							}
							else {
								this.avatar = "https://ui-avatars.com/api/?name=" + this.userName.split(" ")[0].substring(0,1) + "+" + this.userName.split(" ")[1].substring(0,1) + "&size=512&background=344281&color=ffffff";
							}
						} else{
							this.avatar = res.response.userProfileAvatarUrl;
						}
						this.mode = res.response.newSessionOpened == true ? "In" : "Out";
						this.clockInTime = new Date().toLocaleTimeString("en-US", {
							hour: "numeric",
							hour12: true,
							minute: "2-digit",
							second: "2-digit"
						});
						this.openModal();
					}, 1000);
					this.fobScannedEntity.fobId = "";
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
					this.isLoading = false;
					this.fobScannedEntity.fobId = "";
				}
			);
	}

	private updateTime(): void {
		const now = new Date();
		this.currentTime = now.toLocaleTimeString("en-US", {
			hour: "numeric",
			hour12: true,
			minute: "2-digit"
		});

		this.currentDate = now.toLocaleDateString("en-US", {
			day: "numeric",
			month: "short",
			weekday: "long",
			year: "numeric"
		});
	}


	windowWidthCheck() {
		return window.innerWidth >= 768;
	}
}